// extracted by mini-css-extract-plugin
export var container = "_6i-0";
export var fallback = "_6i-5";
export var fallbackIcon = "_6i-6";
export var hidden = "_6i-2";
export var image = "_6i-3";
export var loaded = "_6i-4";
export var placeholder = "_6i-1";